var exports = {
  "R": "avatarWrapper__3X3Vgi",
};

module.exports = exports;
